// Interactive "Nuestra historia" timeline: year nodes act as tabs; activating a
// year reveals its milestone panel. Keyboard: ←/→ move between years (roving
// tabindex), Home/End jump to first/last. Progressive enhancement — markup ships
// with the first milestone visible, so this only adds interactivity.

function initTimeline(wrap) {
  const tabs   = Array.from(wrap.querySelectorAll('[data-timeline-tab]'));
  const panels = Array.from(wrap.querySelectorAll('.timeline-x__panel'));
  if (!tabs.length) return;

  function activate(index, focus) {
    tabs.forEach((tab, i) => {
      const on = i === index;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
      if (on && focus) tab.focus();
    });
    panels.forEach((panel, i) => {
      const on = i === index;
      panel.classList.toggle('is-active', on);
      if (on) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    });
  }

  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => activate(i, false));
    tab.addEventListener('keydown', (e) => {
      let next = null;
      if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      if (next !== null) { e.preventDefault(); activate(next, true); }
    });
  });
}

function initTimelines() {
  document.querySelectorAll('[data-timeline]').forEach(initTimeline);
}

if (document.readyState !== 'loading') initTimelines();
else document.addEventListener('DOMContentLoaded', initTimelines);
